export default __webpack_public_path__ + "static/media/16.28f3c820.png";